/**
 * The single source for the modal exit window.
 *
 * Both halves of the seam wait it out before doing something irreversible —
 * the declarative one before firing `afterClose`, the imperative one before
 * unmounting its own React root — so the two must move together, and the value
 * has to match the `duration-200` the shadcn Dialog and AlertDialog panels
 * animate with (`src/components/ui/{dialog,alert-dialog}.tsx`).
 */
export const MODAL_EXIT_MS = 200
